// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.page-module__page___za1qn {
  background-color: var(--base, #f4f4f7);
}
.page-module__page--white___zMwVA {
  background-color: var(--surface1, #fff);
}
.page-module__page--grey-mobile___UX9mh {
  background-color: var(--base, #f4f4f7);
}
@media (min-width: 48em) {
  .page-module__page--grey-mobile___UX9mh {
    background-color: var(--surface1, #fff);
  }
}
.page-module__page--tier-rewards___McXhg {
  overflow: hidden;
  height: 100%;
  background-color: var(--surface1, #fff);
}
@media (min-width: 48em) {
  .page-module__page--tier-rewards___McXhg {
    background-color: var(--base, #f4f4f7);
  }
}
.page-module__page--trusted-apps-and-websites___z4371 {
  overflow: hidden;
  height: 100%;
  background-color: var(--base, #f4f4f7);
}
.page-module__page--tier-activity___cFj7L {
  padding-bottom: 50px;
}
.page-module__page--groups-list___HpZRF {
  min-height: calc(100vh - 60px);
}

.page-module__hero___V7X0o {
  display: block;
  position: relative;
  z-index: 0;
}
.page-module__hero__bg___XkU8z {
  display: block;
  position: absolute;
  background: var(--primary200, #d8cbe5);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  padding: 10px;
}
.page-module__hero__children___caYOZ {
  padding: 10px;
  max-width: 480px;
  margin: 0 auto;
}
@media (min-width: 48em) {
  .page-module__hero__children___caYOZ {
    max-width: 748px;
  }
}
@media (min-width: 64em) {
  .page-module__hero__children___caYOZ {
    max-width: 940px;
  }
}
@media (min-width: 100em) {
  .page-module__hero__children___caYOZ {
    max-width: 940px;
  }
}
@media (min-width: 48em) {
  .page-module__hero__children___caYOZ {
    padding: 20px 0;
  }
}
.page-module__hero__primary50___QtZgp {
  background: var(--primary50, #f2eff4);
}

.page-module__center___sl6U5 {
  text-align: center;
}

.page-module__content___SihwW {
  max-width: 480px;
  background-color: var(--base, #f4f4f7);
  margin: 0 auto;
  padding: 10px;
}
@media (min-width: 48em) {
  .page-module__content___SihwW {
    max-width: 748px;
  }
}
@media (min-width: 64em) {
  .page-module__content___SihwW {
    max-width: 940px;
  }
}
@media (min-width: 100em) {
  .page-module__content___SihwW {
    max-width: 940px;
  }
}
@media (min-width: 48em) {
  .page-module__content___SihwW {
    padding: 20px 0;
  }
}
.page-module__content--white___f26Yr {
  background-color: var(--surface1, #fff);
}
.page-module__content--health-coaching___C5IUj {
  max-width: 600px;
}
@media (min-width: 48em) {
  .page-module__content--health-coaching___C5IUj {
    padding: 50px 0;
  }
}
.page-module__content--health-coaching___C5IUj {
  max-width: 600px;
}
@media (min-width: 48em) {
  .page-module__content--health-coaching___C5IUj {
    padding: 50px 0;
  }
}
@media (min-width: 64em) {
  .page-module__content--wellbeing-hub___pvVK0 {
    max-width: 944px;
  }
}
@media (min-width: 100em) {
  .page-module__content--wellbeing-hub___pvVK0 {
    max-width: 944px;
  }
}
.page-module__content--trusted-apps-and-websites___TdF8p {
  max-width: 320px;
}
@media (min-width: 48em) {
  .page-module__content--trusted-apps-and-websites___TdF8p {
    max-width: 743px;
  }
}
@media (min-width: 64em) {
  .page-module__content--trusted-apps-and-websites___TdF8p {
    max-width: 940px;
  }
}
.page-module__content--full-height____kgLm {
  min-height: 100vh;
}
.page-module__content--transparent___kwOUd {
  background-color: transparent;
}
.page-module__content--no-padding___oF75j {
  padding: 0;
}
@media (min-width: 48em) {
  .page-module__content--no-padding___oF75j {
    padding: 0;
  }
}
@media (max-width: 47.99em) {
  .page-module__content--wide-mobile___uvpOv {
    max-width: none;
    margin: 0 16px;
  }
}
.page-module__content--programs-all-lists___KNitL {
  background-color: var(--surface1, #fff);
  padding: 24px 0 40px;
}
.page-module__content--programs-hero___NKk7V {
  padding-top: 16px;
}
@media (max-width: 47.99em) {
  .page-module__content--programs-hero___NKk7V {
    padding-top: 24px;
  }
}
.page-module__content--groups-feed-hero___fUbwf {
  padding-top: 8px;
  padding-bottom: 24px;
}
@media (min-width: 64em) {
  .page-module__content--groups-feed-hero___fUbwf {
    padding-top: 0;
  }
}
.page-module__content--full-width___DfqH6 {
  max-width: none;
  padding-left: 16px;
  padding-right: 16px;
  margin: 0;
}
@media (min-width: 48em) {
  .page-module__content--full-width___DfqH6 {
    max-width: 480px;
    margin: 0 auto;
  }
}
@media (min-width: 48em) and (min-width: 48em) {
  .page-module__content--full-width___DfqH6 {
    max-width: 748px;
  }
}
@media (min-width: 48em) and (min-width: 64em) {
  .page-module__content--full-width___DfqH6 {
    max-width: 940px;
  }
}
@media (min-width: 48em) and (min-width: 100em) {
  .page-module__content--full-width___DfqH6 {
    max-width: 940px;
  }
}
.page-module__content--tier-rewards___bLFoE {
  max-width: 720px;
  padding: 16px 0 0;
}
@media (min-width: 64em) {
  .page-module__content--tier-rewards___bLFoE {
    padding-top: 24px;
    max-width: 1020px;
  }
}

@media (min-width: 23.4375em) {
  .page-module__full-width___yrAeq {
    max-width: 100%;
  }
}

@media (min-width: 23.4375em) and (max-width: 99.99em) {
  .page-module__no-padding___CKPwu {
    padding: 0;
  }
}

.page-module__transparent___AqM66 {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/layouts/page/page.module.scss","webpack://./node_modules/sass-mq/_mq.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_page-max-widths.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,sCAAA;AAMF;AAJE;EACE,uCAAA;AAMJ;AAHE;EACE,sCAAA;AAKJ;ACiKE;EDvKA;IAGI,uCAAA;EAOJ;AACF;AAJE;EACE,gBAAA;EACA,YAAA;EACA,uCAAA;AAMJ;ACuJE;EDhKA;IAMI,sCAAA;EAOJ;AACF;AAJE;EACE,gBAAA;EACA,YAAA;EACA,sCAAA;AAMJ;AAHE;EACE,oBAAA;AAKJ;AAFE;EACE,8BAAA;AAIJ;;AAAA;EACE,cAAA;EACA,kBAAA;EACA,UAAA;AAGF;AADE;EACE,cAAA;EACA,kBAAA;EACA,sCAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;AAGJ;AAAE;EACE,aAAA;EE1DF,gBAAA;EF4DE,cAAA;AAEJ;ACiHE;EDtHA;IEtDE,gBAAA;EF+DF;AACF;AC4GE;EDtHA;IElDE,gBAAA;EFgEF;AACF;ACuGE;EDtHA;IE9CE,gBAAA;EFiEF;AACF;ACkGE;EDtHA;IAMI,eAAA;EAkBJ;AACF;AAfE;EACE,qCAAA;AAiBJ;;AAbA;EACE,kBAAA;AAgBF;;AAbA;EE5EE,gBAAA;EF8EA,sCAAA;EACA,cAAA;EACA,aAAA;AAgBF;AC+EE;EDnGF;IEzEI,gBAAA;EFiGF;AACF;AC0EE;EDnGF;IErEI,gBAAA;EFkGF;AACF;ACqEE;EDnGF;IEjEI,gBAAA;EFmGF;AACF;ACgEE;EDnGF;IAOI,eAAA;EAgCF;AACF;AA9BE;EACE,uCAAA;AAgCJ;AA7BE;EACE,gBAAA;AA+BJ;ACqDE;EDrFA;IAGI,eAAA;EAiCJ;AACF;AA9BE;EACE,gBAAA;AAgCJ;AC6CE;ED9EA;IAGI,eAAA;EAkCJ;AACF;ACwCE;EDvEA;IAEI,gBAAA;EAiCJ;AACF;ACmCE;EDvEA;IAMI,gBAAA;EAkCJ;AACF;AA/BE;EACE,gBAAA;AAiCJ;AC2BE;ED7DA;IAII,gBAAA;EAkCJ;AACF;ACsBE;ED7DA;IAQI,gBAAA;EAmCJ;AACF;AAhCE;EACE,iBAAA;AAkCJ;AA/BE;EACE,6BAAA;AAiCJ;AA9BE;EACE,UAAA;AAgCJ;ACQE;EDzCA;IAII,UAAA;EAiCJ;AACF;ACGE;EDjCA;IAEI,eAAA;IACA,cAAA;EAgCJ;AACF;AA7BE;EACE,uCAAA;EACA,oBAAA;AA+BJ;AA5BE;EACE,iBAAA;AA8BJ;ACVE;EDrBA;IAII,iBAAA;EA+BJ;AACF;AA5BE;EACE,gBAAA;EACA,oBAAA;AA8BJ;ACnBE;EDbA;IAII,cAAA;EAgCJ;AACF;AA7BE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AA+BJ;AC9BE;EDLA;IE1KA,gBAAA;IFkLI,cAAA;EAgCJ;AACF;ACpCE;EDLA;IEvKE,gBAAA;EFoNF;AACF;ACzCE;EDLA;IEnKE,gBAAA;EFqNF;AACF;AC9CE;EDLA;IE/JE,gBAAA;EFsNF;AACF;AA5CE;EACE,gBAAA;EACA,iBAAA;AA8CJ;ACvDE;EDOA;IAKI,iBAAA;IACA,iBAAA;EA+CJ;AACF;;AC7DE;EDkBF;IAEI,eAAA;EA8CF;AACF;;ACnEE;EDwBF;IAEI,UAAA;EA8CF;AACF;;AA3CA;EACE,6BAAA;AA8CF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils.scss';\n\n.page {\n  background-color: color(base);\n\n  &--white {\n    background-color: color(surface1);\n  }\n\n  &--grey-mobile {\n    background-color: color(base);\n    @include mq($from: tablet) {\n      background-color: color(surface1);\n    }\n  }\n\n  &--tier-rewards {\n    overflow: hidden;\n    height: 100%;\n    background-color: color(surface1);\n\n    @include mq($from: tablet) {\n      background-color: color(base);\n    }\n  }\n\n  &--trusted-apps-and-websites {\n    overflow: hidden;\n    height: 100%;\n    background-color: color(base);\n  }\n\n  &--tier-activity {\n    padding-bottom: 50px;\n  }\n\n  &--groups-list {\n    min-height: calc(100vh - 60px);\n  }\n}\n\n.hero {\n  display: block;\n  position: relative;\n  z-index: 0;\n\n  &__bg {\n    display: block;\n    position: absolute;\n    background: color(primary200);\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: -1;\n    padding: $spacing * 0.5;\n  }\n\n  &__children {\n    padding: $spacing * 0.5;\n    @include page-max-widths;\n    margin: 0 auto;\n\n    @include mq($from: tablet) {\n      padding: $spacing 0;\n    }\n  }\n\n  &__primary50 {\n    background: color(primary50);\n  }\n}\n\n.center {\n  text-align: center;\n}\n\n.content {\n  @include page-max-widths;\n  background-color: color(base);\n  margin: 0 auto;\n  padding: $spacing * 0.5;\n\n  @include mq($from: tablet) {\n    padding: $spacing 0;\n  }\n\n  &--white {\n    background-color: color(surface1);\n  }\n\n  &--health-coaching {\n    max-width: 600px;\n    @include mq($from: tablet) {\n      padding: 50px 0;\n    }\n  }\n\n  &--health-coaching {\n    max-width: 600px;\n    @include mq($from: tablet) {\n      padding: 50px 0;\n    }\n  }\n\n  &--wellbeing-hub {\n    @include mq($from: wide) {\n      max-width: 944px;\n    }\n\n    @include mq($from: extra-wide) {\n      max-width: 944px;\n    }\n  }\n\n  &--trusted-apps-and-websites {\n    max-width: 320px;\n\n    @include mq($from: tablet) {\n      max-width: 743px;\n    }\n\n    @include mq($from: wide) {\n      max-width: 940px;\n    }\n  }\n\n  &--full-height {\n    min-height: 100vh;\n  }\n\n  &--transparent {\n    background-color: transparent;\n  }\n\n  &--no-padding {\n    padding: 0;\n\n    @include mq($from: tablet) {\n      padding: 0;\n    }\n  }\n\n  &--wide-mobile {\n    @include mq($until: tablet) {\n      max-width: none;\n      margin: 0 16px;\n    }\n  }\n\n  &--programs-all-lists {\n    background-color: color(surface1);\n    padding: 24px 0 40px;\n  }\n\n  &--programs-hero {\n    padding-top: 16px;\n\n    @include mq($until: tablet) {\n      padding-top: 24px;\n    }\n  }\n\n  &--groups-feed-hero {\n    padding-top: 8px;\n    padding-bottom: 24px;\n    @include mq($from: wide) {\n      padding-top: 0;\n    }\n  }\n\n  &--full-width {\n    max-width: none;\n    padding-left: 16px;\n    padding-right: 16px;\n    margin: 0;\n\n    @include mq($from: tablet) {\n      @include page-max-widths;\n      margin: 0 auto;\n    }\n  }\n\n  &--tier-rewards {\n    max-width: 720px;\n    padding: 16px 0 0;\n\n    @include mq($from: wide) {\n      padding-top: 24px;\n      max-width: 1020px;\n    }\n  }\n}\n\n.full-width {\n  @include mq($from: mobile) {\n    max-width: 100%;\n  }\n}\n\n.no-padding {\n  @include mq($from: mobile, $until: extra-wide) {\n    padding: 0;\n  }\n}\n\n.transparent {\n  background-color: transparent;\n}\n","@use 'sass:math';\n@use 'sass:map';\n@use 'sass:list';\n\n/// Breakpoint list\n///\n/// Name your breakpoints in a way that creates a ubiquitous language\n/// across team members. It will improve communication between\n/// stakeholders, designers, developers, and testers.\n///\n/// @type Map\n/// @link https://github.com/sass-mq/sass-mq#seeing-the-currently-active-breakpoint Full documentation and examples\n$breakpoints: (\n  mobile: 320px,\n  tablet: 740px,\n  desktop: 980px,\n  wide: 1300px,\n) !default;\n\n/// Show breakpoints in the top right corner\n///\n/// If you want to display the currently active breakpoint in the top\n/// right corner of your site during development, add the breakpoints\n/// to this list, ordered by width. For example: (mobile, tablet, desktop).\n///\n/// @example scss\n///   @use 'path/to/mq' with ($show-breakpoints: ('mobile', 'tablet', 'desktop'));\n///\n///\n/// @type map\n$show-breakpoints: () !default;\n\n/// Customize the media type (for example: `@media screen` or `@media print`)\n/// By default sass-mq uses an \"all\" media type (`@media all and …`)\n///\n/// If you want to overried the media type, you can use this option.\n/// @example scss\n///   @use 'path/to/mq' with ($media-type: 'screen');\n///\n/// @type String\n/// @link https://github.com/sass-mq/sass-mq#changing-media-type Full documentation and example\n$media-type: all !default;\n\n/// Convert pixels to ems\n///\n/// @param {Number} $px - value to convert\n///\n/// @example scss\n///  $font-size-in-ems: px2em(16px);\n///  p { font-size: px2em(16px); }\n///\n/// @returns {Number}\n\n@function px2em($px) {\n  @if math.is-unitless($px) {\n    @warn \"Assuming #{$px} to be in pixels, attempting to convert it into pixels.\";\n    @return px2em($px * 1px);\n  }\n  // if $px is compatible with em units, then return value unchanged\n  @if math.compatible($px, 1em) {\n    @return $px;\n  }\n  @return math.div($px, 16px) * 1em;\n}\n\n/// Get a breakpoint's width\n///\n/// @param {String} $name - Name of the breakpoint. One of $breakpoints\n///\n/// @example scss\n///  $tablet-width: get-breakpoint-width(tablet);\n///  @media (min-width: get-breakpoint-width(tablet)) {}\n///\n/// @requires {Variable} $breakpoints\n///\n/// @returns {Number} Value in pixels\n@function get-breakpoint-width($name, $breakpoints: $breakpoints) {\n  @if map.has-key($breakpoints, $name) {\n    @return map.get($breakpoints, $name);\n  } @else {\n    @warn \"Breakpoint #{$name} wasn't found in $breakpoints.\";\n    @return null;\n  }\n}\n\n/// Media Query mixin\n///\n/// @param {String | Boolean} $from [false] - One of $breakpoints\n/// @param {String | Boolean} $until [false] - One of $breakpoints\n/// @param {String | Boolean} $and [false] - Additional media query parameters\n/// @param {String} $media-type [$media-type] - Media type: screen, print…\n///\n/// @ignore Undocumented API, for advanced use only:\n/// @ignore @param {Map} $breakpoints [$breakpoints]\n///\n/// @content styling rules, wrapped into a @media query when $responsive is true\n///\n/// @requires {Variable} $media-type\n/// @requires {Variable} $breakpoints\n/// @requires {function} px2em\n/// @requires {function} get-breakpoint-width\n///\n/// @link https://github.com/sass-mq/sass-mq#responsive-mode-on-default Full documentation and examples\n///\n/// @example scss\n///  @use 'path/to/mq' as *;\n///  .element {\n///    @include mq($from: mobile) {\n///      color: red;\n///    }\n///    @include mq($until: tablet) {\n///      color: blue;\n///    }\n///    @include mq(mobile, tablet) {\n///      color: green;\n///    }\n///    @include mq($from: tablet, $and: '(orientation: landscape)') {\n///      color: teal;\n///    }\n///    @include mq(950px) {\n///      color: hotpink;\n///    }\n///    @include mq(tablet, $media-type: screen) {\n///      color: hotpink;\n///    }\n///    // Advanced use:\n///    $my-breakpoints: (L: 900px, XL: 1200px);\n///    @include mq(L, $breakpoints: $my-breakpoints) {\n///      color: hotpink;\n///    }\n///  }\n@mixin mq(\n  $from: false,\n  $until: false,\n  $and: false,\n  $media-type: $media-type,\n  $breakpoints: $breakpoints\n) {\n  $min-width: 0;\n  $max-width: 0;\n  $media-query: '';\n\n  // From: this breakpoint (inclusive)\n  @if $from {\n    @if type-of($from) == number {\n      $min-width: px2em($from);\n    } @else {\n      $min-width: px2em(get-breakpoint-width($from, $breakpoints));\n    }\n  }\n\n  // Until: that breakpoint (exclusive)\n  @if $until {\n    @if type-of($until) == number {\n      $max-width: px2em($until);\n    } @else {\n      $max-width: px2em(get-breakpoint-width($until, $breakpoints)) - 0.01em;\n    }\n  }\n\n  @if $min-width != 0 {\n    $media-query: '#{$media-query} and (min-width: #{$min-width})';\n  }\n  @if $max-width != 0 {\n    $media-query: '#{$media-query} and (max-width: #{$max-width})';\n  }\n  @if $and {\n    $media-query: '#{$media-query} and #{$and}';\n  }\n\n  // Remove unnecessary media query prefix 'all and '\n  @if ($media-type == 'all' and $media-query != '') {\n    $media-type: '';\n    $media-query: str-slice(unquote($media-query), 6);\n  }\n\n  @media #{$media-type + $media-query} {\n    @content;\n  }\n}\n\n/// Quick sort\n///\n/// @author Sam Richards\n/// @access private\n/// @param {List} $list - List to sort\n/// @returns {List} Sorted List\n@function _quick-sort($list) {\n  $less: ();\n  $equal: ();\n  $large: ();\n\n  @if length($list) > 1 {\n    $seed: list.nth($list, math.ceil(math.div(length($list), 2)));\n\n    @each $item in $list {\n      @if ($item == $seed) {\n        $equal: list.append($equal, $item);\n      } @else if ($item < $seed) {\n        $less: list.append($less, $item);\n      } @else if ($item > $seed) {\n        $large: list.append($large, $item);\n      }\n    }\n\n    @return join(join(_quick-sort($less), $equal), _quick-sort($large));\n  }\n\n  @return $list;\n}\n\n/// Sort a map by values (works with numbers only)\n///\n/// @access private\n/// @param {Map} $map - Map to sort\n/// @returns {Map} Map sorted by value\n@function _map-sort-by-value($map) {\n  $map-sorted: ();\n  $map-keys: map.keys($map);\n  $map-values: map.values($map);\n  $map-values-sorted: _quick-sort($map-values);\n\n  // Reorder key/value pairs based on key values\n  @each $value in $map-values-sorted {\n    $index: index($map-values, $value);\n    $key: list.nth($map-keys, $index);\n    $map-sorted: map.merge(\n      $map-sorted,\n      (\n        $key: $value,\n      )\n    );\n\n    // Unset the value in $map-values to prevent the loop\n    // from finding the same index twice\n    $map-values: list.set-nth($map-values, $index, 0);\n  }\n\n  @return $map-sorted;\n}\n\n/// Add a breakpoint\n///\n/// @param {String} $name - Name of the breakpoint\n/// @param {Number} $width - Width of the breakpoint\n///\n/// @requires {Variable} $breakpoints\n///\n/// @example scss\n///  @include add-breakpoint(tvscreen, 1920px);\n///  @include mq(tvscreen) {}\n@mixin add-breakpoint($name, $width) {\n  $new-breakpoint: (\n    $name: $width,\n  );\n  $breakpoints: map.merge($breakpoints, $new-breakpoint) !global;\n  $breakpoints: _map-sort-by-value($breakpoints) !global;\n}\n\n/// Show the active breakpoint in the top right corner of the viewport\n/// @link https://github.com/sass-mq/sass-mq#seeing-the-currently-active-breakpoint\n///\n/// @param {List} $show-breakpoints [$show-breakpoints] - List of breakpoints to show in the top right corner\n/// @param {Map} $breakpoints [$breakpoints] - Breakpoint names and sizes\n///\n/// @requires {Variable} $breakpoints\n/// @requires {Variable} $show-breakpoints\n///\n/// @example scss\n///  // Show breakpoints using global settings\n///  @include show-breakpoints;\n///\n///  // Show breakpoints using custom settings\n///  @include show-breakpoints((L, XL), (S: 300px, L: 800px, XL: 1200px));\n@mixin show-breakpoints(\n  $show-breakpoints: $show-breakpoints,\n  $breakpoints: $breakpoints\n) {\n  body:before {\n    background-color: #fcf8e3;\n    border-bottom: 1px solid #fbeed5;\n    border-left: 1px solid #fbeed5;\n    color: #c09853;\n    font: small-caption;\n    padding: 3px 6px;\n    pointer-events: none;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 100;\n\n    // Loop through the breakpoints that should be shown\n    @each $show-breakpoint in $show-breakpoints {\n      $width: get-breakpoint-width($show-breakpoint, $breakpoints);\n      @include mq($show-breakpoint, $breakpoints: $breakpoints) {\n        content: '#{$show-breakpoint} ≥ #{$width} (#{px2em($width)})';\n      }\n    }\n  }\n}\n\n@if list.length($show-breakpoints) > 0 {\n  @include show-breakpoints;\n}\n","@mixin page-max-widths() {\n  max-width: dim($page-max-widths, mobile);\n\n  @include mq($from: tablet) {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n  @include mq($from: wide) {\n    max-width: dim($page-max-widths, wide);\n  }\n\n  @include mq($from: extra-wide) {\n    max-width: dim($page-max-widths, extra-wide);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page-module__page___za1qn`,
	"page--white": `page-module__page--white___zMwVA`,
	"page--grey-mobile": `page-module__page--grey-mobile___UX9mh`,
	"page--tier-rewards": `page-module__page--tier-rewards___McXhg`,
	"page--trusted-apps-and-websites": `page-module__page--trusted-apps-and-websites___z4371`,
	"page--tier-activity": `page-module__page--tier-activity___cFj7L`,
	"page--groups-list": `page-module__page--groups-list___HpZRF`,
	"hero": `page-module__hero___V7X0o`,
	"hero__bg": `page-module__hero__bg___XkU8z`,
	"hero__children": `page-module__hero__children___caYOZ`,
	"hero__primary50": `page-module__hero__primary50___QtZgp`,
	"center": `page-module__center___sl6U5`,
	"content": `page-module__content___SihwW`,
	"content--white": `page-module__content--white___f26Yr`,
	"content--health-coaching": `page-module__content--health-coaching___C5IUj`,
	"content--wellbeing-hub": `page-module__content--wellbeing-hub___pvVK0`,
	"content--trusted-apps-and-websites": `page-module__content--trusted-apps-and-websites___TdF8p`,
	"content--full-height": `page-module__content--full-height____kgLm`,
	"content--transparent": `page-module__content--transparent___kwOUd`,
	"content--no-padding": `page-module__content--no-padding___oF75j`,
	"content--wide-mobile": `page-module__content--wide-mobile___uvpOv`,
	"content--programs-all-lists": `page-module__content--programs-all-lists___KNitL`,
	"content--programs-hero": `page-module__content--programs-hero___NKk7V`,
	"content--groups-feed-hero": `page-module__content--groups-feed-hero___fUbwf`,
	"content--full-width": `page-module__content--full-width___DfqH6`,
	"content--tier-rewards": `page-module__content--tier-rewards___bLFoE`,
	"full-width": `page-module__full-width___yrAeq`,
	"no-padding": `page-module__no-padding___CKPwu`,
	"transparent": `page-module__transparent___AqM66`
};
export default ___CSS_LOADER_EXPORT___;
